import { render, staticRenderFns } from "./RecoverViaSms.vue?vue&type=template&id=cc355e58&"
import script from "./RecoverViaSms.vue?vue&type=script&lang=js&"
export * from "./RecoverViaSms.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports